import { MutationTree, GetterTree } from 'vuex';
import { ICustomerState } from './types';
const state: ICustomerState = {
	idCustomer: null,
	customerName: null
};

const mutations: MutationTree<ICustomerState> = {
	setIdCustomer(customerState: ICustomerState, idCustomer: string): void {
		customerState.idCustomer = idCustomer;
	},
	setCustomerName(customerState: ICustomerState, name: string): void {
		customerState.customerName = name;
	}
};

const getters: GetterTree<ICustomerState, unknown> = {
	idCustomer(customerState: ICustomerState): string | null {
		return customerState.idCustomer;
	},
	customerName(customerState: ICustomerState): string | null {
		return customerState.customerName;
	}
};

export const customerStore = {
	namespaced: true,
	state,
	mutations,
	getters
};
